<template>
  <RevIllustration
    v-if="partner === 'uswitch'"
    alt="Uswitch"
    :height="24"
    src="/img/uswitch/uswitch-logo.svg"
    :width="78"
  />
</template>

<script setup lang="ts">
import { useRoute } from '#imports'

import { RevIllustration } from '@ds/components/Illustration'

const props = defineProps<{
  partnerName?: string
}>()

const route = useRoute()

const partner = props.partnerName ?? route.query.partner
</script>
